import * as React from 'react';
import * as style from './Heading.css';

interface IHeading {
  name: string;
}

export const Heading = ({ name }: IHeading) => {
  return (
    <div className={style['heading']}>
      <h1>
        Застройщик <br /> {name}
      </h1>
    </div>
  );
};
